import { IdName } from 'src/app/shared/models/id-name';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { ICopyCompetenceRequirementModel } from '../model/competence-requirement-copy.model';
import { ICompetenceRequirementModel } from '../model/competence-requirement.model';

@Injectable({
  providedIn: 'root',
})
export class CompetenceRequirementsApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Competence/CompetenceRequirement`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  getCompetenceRequirements(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<ICompetenceRequirementModel[]>> {
    let url = `${this.baseUrl}/`;
    if (currentFilter) {
      url = `${url}?Page=${currentFilter.pageIndex}&PageSize=${currentFilter.pageSize}`;
    }
    if (currentFilter?.searchTerm) {
      url = `${url}&GlobalSearch=${currentFilter.searchTerm}`;
    }
    if (currentFilter?.orderBy && currentFilter.ascDesc) {
      url = `${url}&OrderBy[${currentFilter.orderBy}]=${currentFilter.ascDesc}`;
    }

    return this.http.get<ApiResponse<ICompetenceRequirementModel[]>>(url, this.httpOptions);
  }

  getAllCompetenceRequirements(): Observable<IdName[]> {
    const url = `${this.baseUrl}/List`;
    return this.http.get<IdName[]>(url, this.httpOptions);
  }

  addCompetenceRequirement(
    competenceRequirement: ICompetenceRequirementModel
  ): Observable<ICompetenceRequirementModel> {
    const url = this.baseUrl;
    return this.http.post<ICompetenceRequirementModel>(
      url,
      competenceRequirement,
      this.httpOptions
    );
  }

  getCompetenceRequirementsById(id: string): Observable<ICompetenceRequirementModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<ICompetenceRequirementModel>(url, this.httpOptions);
  }

  updateCompetenceRequirement(competenceRequirement: ICompetenceRequirementModel) {
    const url = `${this.baseUrl}/${competenceRequirement.id}`;
    return this.http.put<void>(url, competenceRequirement, this.httpOptions);
  }

  deleteCompetenceRequirement(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<void>(url, this.httpOptions);
  }

  copyCompetenceRequirement(copyCompetenceReq: ICopyCompetenceRequirementModel): Observable<void> {
    const url = `${this.baseUrl}/Copy`;
    return this.http.put<void>(url, copyCompetenceReq, this.httpOptions);
  }
}
